import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { badgeCounts } from "../lib/nav";

const API = "/api";
const REFRESH_INTERVAL = 60_000; // 1 minute

const EMPTY = { total: 0, has_critical: false, items: [] };
const NotificationSummaryContext = createContext({ summary: EMPTY, badges: {}, refresh: () => {} });

/**
 * One poll of /api/notifications/summary for the whole layout: the bell, the
 * sidebar's badges and the phone tab bar all read it, instead of each asking
 * the server every minute.
 */
export function NotificationSummaryProvider({ children }) {
  const [summary, setSummary] = useState(EMPTY);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/notifications/summary`);
      const data = res?.data;
      if (data && Array.isArray(data.items)) setSummary(data);
    } catch {
      // Silent — a missed count must not get in the user's way.
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, REFRESH_INTERVAL);
    return () => clearInterval(id);
  }, [refresh]);

  const value = useMemo(
    () => ({ summary, badges: badgeCounts(summary.items), refresh }),
    [summary, refresh],
  );
  return React.createElement(NotificationSummaryContext.Provider, { value }, children);
}

export function useNotificationSummary() {
  return useContext(NotificationSummaryContext);
}
